import { Typography, type TypographyProps } from '@mui/material';

import { GRID_AREA_TITLE } from 'shared/components/Tile/components/Header/constants';

import type { FC } from 'react';

export const Title: FC<TypographyProps> = ({ children, ...props }) => (
  <Typography sx={{ gridArea: GRID_AREA_TITLE }} variant="h5" {...props}>
    {children}
  </Typography>
);
